import React from 'react'
import styled from 'styled-components'

/**
 * Official ELSTER brand mark (green star) from elster.de assets
 * (safari-pinned-tab / portal sprite path). Brand green: #94C502.
 */
const ELSTER_STAR_PATH =
  'M6.62 6.77 1.1 4.97.17 7.52 5.8 9.34l-3.42 4.73 2.2 1.64L8 11l3.44 4.7 2.27-1.63-3.5-4.73 5.61-1.83-.91-2.55-5.53 1.8L9.37.83H6.63'

type ElsterLogoVariant = 'logo' | 'tagline' | 'star'

interface Props {
  variant?: ElsterLogoVariant
  height?: number
  className?: string
}

export const ElsterLogo: React.FC<Props> = ({ variant = 'logo', height = 28, className }) => {
  if (variant === 'star') {
    return (
      <StarOnly
        className={className}
        $size={height}
        viewBox="0 0 16 16"
        role="img"
        aria-label="ELSTER"
      >
        <path fill="#94C502" d={ELSTER_STAR_PATH} />
      </StarOnly>
    )
  }

  return (
    <Lockup className={className} $height={height} role="img" aria-label="ELSTER">
      <StarSvg viewBox="0 0 16 16" aria-hidden>
        <path fill="#94C502" d={ELSTER_STAR_PATH} />
      </StarSvg>
      <Wordmark>ELSTER</Wordmark>
      {variant === 'tagline' && <Tagline>Ihr Online-Finanzamt</Tagline>}
    </Lockup>
  )
}

const StarOnly = styled.svg<{ $size: number }>`
  display: block;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  flex-shrink: 0;
`

const Lockup = styled.div<{ $height: number }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ $height }) => Math.max(6, Math.round($height * 0.28))}px;
  height: ${({ $height }) => $height}px;
  font-size: ${({ $height }) => $height}px;
  line-height: 1;
`

const StarSvg = styled.svg`
  height: 100%;
  width: auto;
  aspect-ratio: 1;
  flex-shrink: 0;
`

const Wordmark = styled.span`
  color: #94c502;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 700;
  font-size: 0.72em;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`

const Tagline = styled.span`
  color: #555555;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 400;
  font-size: 0.4em;
  margin-left: 0.1em;
  white-space: nowrap;
`
